var _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMemberVerified(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 121,
    viewBox: "0 0 126 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 46H12.5C10.8431 46 9.5 47.3431 9.5 49V97C9.5 98.6569 10.8431 100 12.5 100H84.5C86.1569 100 87.5 98.6569 87.5 97V49C87.5 47.3431 86.1569 46 84.5 46Z",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5 88H51.5",
    stroke: "#005E3C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 88H27.5",
    stroke: "#005E3C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4978 61.3196H87.4978",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 85.5,
    cy: 40,
    r: 37,
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4375 62.3044C67.3207 58.6019 70.1916 55.4928 73.7326 53.3211C77.2736 51.1495 81.3464 50 85.5003 50C89.6541 50 93.727 51.1494 97.2679 53.3211C100.809 55.4927 103.68 58.6019 105.563 62.3043",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 70C102.069 70 115.5 56.5685 115.5 40C115.5 23.4315 102.069 10 85.5 10C68.9315 10 55.5 23.4315 55.5 40C55.5 56.5685 68.9315 70 85.5 70Z",
    stroke: "#005E3C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 50C92.4036 50 98 44.4036 98 37.5C98 30.5964 92.4036 25 85.5 25C78.5964 25 73 30.5964 73 37.5C73 44.4036 78.5964 50 85.5 50Z",
    stroke: "#191919",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberVerified);
export default __webpack_public_path__ + "static/media/member_verified.8ab6fb0517a099bd8fd446ca2b4a3c42.svg";
export { ForwardRef as ReactComponent };